module.exports = __webpack_public_path__ + "static/media/logo.9476a1cb.png";